import { IconWrapper } from '../runtime';
export default IconWrapper('unknown_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#5F6A72"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#8999A3"
    }
  }), h("path", {
    "attrs": {
      "d": "M6.25 5.80078C6.25 5.39984 6.35473 4.85457 6.62827 4.43499C6.87465 4.05709 7.27096 3.75 8 3.75C8.6852 3.75 9.09398 3.98208 9.34103 4.26533C9.60282 4.5655 9.75 5.00177 9.75 5.5C9.75 5.94467 9.54979 6.23719 9.19482 6.48573C8.80592 6.75804 8.29107 6.93004 7.78397 7.08257C7.467 7.17791 7.25 7.46977 7.25 7.80078V9H8.75V8.34871C9.16548 8.20466 9.63909 8.00581 10.0552 7.71447C10.7002 7.26281 11.25 6.55533 11.25 5.5C11.25 4.72452 11.0222 3.91079 10.4715 3.27938C9.90602 2.63106 9.0648 2.25 8 2.25C6.72904 2.25 5.87535 2.8433 5.37173 3.61579C4.89527 4.34661 4.75 5.20173 4.75 5.80078H6.25Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.75 11.5V10H7.25V11.5H8.75Z",
      "fill": "white"
    }
  })]);
});